import { Thumbnail } from 'api';
import { isSmallScreen } from './isSmallScreen';

export const defaultImage = 'https://via.placeholder.com/150';
export const getImageUrl = (t: Thumbnail): string => {
  const img = isSmallScreen()
    ? { preferred: t.mobileURL, alternative: t.desktopURL }
    : { preferred: t.desktopURL, alternative: t.mobileURL };
  if (img.preferred) return img.preferred;
  if (img.alternative) return img.alternative;
  return 'https://via.placeholder.com/150';
};
